module.exports = __webpack_public_path__ + "static/media/Adjustable.a507abef.png";